// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'vkFont', 'vkFont Fallback', arial, system-ui, sans-serif"},"className":"hCKQfUHr","variable":"DLOPgVnq"};